webpackJsonp([24],{

/***/ 2046:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _pdfjsDist = __webpack_require__(293);

var _pdfjsDist2 = _interopRequireDefault(_pdfjsDist);

var _load = __webpack_require__(865);

var _load2 = _interopRequireDefault(_load);

var _file_info_preview = __webpack_require__(972);

var _file_info_preview2 = _interopRequireDefault(_file_info_preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var MAX_PDF_PAGES = 5;

var PDFPreview = function (_React$PureComponent) {
    (0, _inherits3.default)(PDFPreview, _React$PureComponent);

    function PDFPreview(props) {
        (0, _classCallCheck3.default)(this, PDFPreview);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PDFPreview.__proto__ || (0, _getPrototypeOf2.default)(PDFPreview)).call(this, props));

        _this.updateStateFromProps = _this.updateStateFromProps.bind(_this);
        _this.onDocumentLoad = _this.onDocumentLoad.bind(_this);
        _this.onDocumentLoadError = _this.onDocumentLoadError.bind(_this);
        _this.onPageLoad = _this.onPageLoad.bind(_this);
        _this.renderPDFPage = _this.renderPDFPage.bind(_this);

        _this.pdfPagesRendered = {};

        _this.state = {
            pdf: null,
            pdfPages: {},
            pdfPagesLoaded: {},
            numPages: 0,
            loading: true,
            success: false
        };
        return _this;
    }

    (0, _createClass3.default)(PDFPreview, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateStateFromProps(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.fileUrl !== nextProps.fileUrl) {
                this.updateStateFromProps(nextProps);
                this.pdfPagesRendered = {};
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.success) {
                for (var i = 0; i < this.state.numPages; i++) {
                    this.renderPDFPage(i);
                }
            }
        }
    }, {
        key: 'renderPDFPage',
        value: function renderPDFPage(pageIndex) {
            if (this.pdfPagesRendered[pageIndex] || !this.state.pdfPagesLoaded[pageIndex]) {
                return;
            }

            var canvas = this.refs['pdfCanvas' + pageIndex];
            var context = canvas.getContext('2d');
            var viewport = this.state.pdfPages[pageIndex].getViewport(1);

            canvas.height = viewport.height;
            canvas.width = viewport.width;

            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };

            this.state.pdfPages[pageIndex].render(renderContext);
            this.pdfPagesRendered[pageIndex] = true;
        }
    }, {
        key: 'updateStateFromProps',
        value: function updateStateFromProps(props) {
            this.setState({
                pdf: null,
                pdfPages: {},
                pdfPagesLoaded: {},
                numPages: 0,
                loading: true,
                success: false
            });

            _pdfjsDist2.default.getDocument(props.fileUrl).then(this.onDocumentLoad, this.onDocumentLoadError);
        }
    }, {
        key: 'onDocumentLoad',
        value: function onDocumentLoad(pdf) {
            var numPages = pdf.numPages <= MAX_PDF_PAGES ? pdf.numPages : MAX_PDF_PAGES;
            this.setState({ pdf: pdf, numPages: numPages });
            for (var i = 1; i <= pdf.numPages; i++) {
                pdf.getPage(i).then(this.onPageLoad);
            }
        }
    }, {
        key: 'onDocumentLoadError',
        value: function onDocumentLoadError(reason) {
            console.log('Unable to load PDF preview: ' + reason); //eslint-disable-line no-console
            this.setState({ loading: false, success: false });
        }
    }, {
        key: 'onPageLoad',
        value: function onPageLoad(page) {
            var pdfPages = (0, _assign2.default)({}, this.state.pdfPages);
            pdfPages[page.pageIndex] = page;

            var pdfPagesLoaded = (0, _assign2.default)({}, this.state.pdfPagesLoaded);
            pdfPagesLoaded[page.pageIndex] = true;

            this.setState({ pdfPages: pdfPages, pdfPagesLoaded: pdfPagesLoaded });

            if (page.pageIndex === 0) {
                this.setState({ success: true, loading: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.loading) {
                return _react2.default.createElement(
                    'div',
                    { className: 'view-image__loading' },
                    _react2.default.createElement('img', {
                        className: 'loader-image',
                        src: _load2.default
                    })
                );
            }

            if (!this.state.success) {
                return _react2.default.createElement(_file_info_preview2.default, {
                    fileInfo: this.props.fileInfo,
                    fileUrl: this.props.fileUrl
                });
            }

            var pdfCanvases = [];
            for (var i = 0; i < this.state.numPages; i++) {
                pdfCanvases.push(_react2.default.createElement('canvas', {
                    ref: 'pdfCanvas' + i,
                    key: 'previewpdfcanvas' + i
                }));

                if (i < this.state.numPages - 1 && this.state.numPages > 1) {
                    pdfCanvases.push(_react2.default.createElement('div', {
                        key: 'previewpdfspacer' + i,
                        className: 'pdf-preview-spacer'
                    }));
                }
            }

            if (this.state.pdf.numPages > MAX_PDF_PAGES) {
                pdfCanvases.push(_react2.default.createElement(
                    'a',
                    {
                        key: 'previewpdfmorepages',
                        href: this.props.fileUrl,
                        className: 'pdf-max-pages'
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'pdf_preview.max_pages',
                        defaultMessage: 'Download to read more pages'
                    })
                ));
            }

            return _react2.default.createElement(
                'div',
                { className: 'post-code' },
                pdfCanvases
            );
        }
    }]);
    return PDFPreview;
}(_react2.default.PureComponent);

PDFPreview.propTypes = {

    /**
    * Compare file types
    */
    fileInfo: _propTypes2.default.object.isRequired,

    /**
    *  URL of pdf file to output and compare to update props url
    */
    fileUrl: _propTypes2.default.string.isRequired
};
exports.default = PDFPreview;

/***/ })

});


// WEBPACK FOOTER //
// 24.71c67645a7031c50f1e5.js